import { useEffect } from "react";
import styles from "./PasswordResetSuccessModal.module.scss";
import PropTypes from "prop-types";
import { TickIcon } from "./AccessKeyModal/AccessKeyModal";

const PasswordResetSuccessModal = ({ visible, onClose }) => {
  useEffect(() => {
    if (visible) {
      const timer = setTimeout(() => {
        onClose();
      }, 6000);
      return () => clearTimeout(timer);
    }
  }, [visible, onClose]);

  if (!visible) return null;

  return (
    <div className={styles.modal}>
      <div className={styles.successIcon}>
        <TickIcon className={styles.iconStyle} />
      </div>
      <div>
        <div>
          <span className={styles.modalTitle}>Success!</span>
        </div>
        <span className={styles.modalMessage}>New password has been set.</span>
      </div>
      <div>
        <button
          className={styles.modalClose}
          onClick={onClose}
          data-testid="success-modal-close-x"
        >
          <i className="tg-icons-Cross"></i>
        </button>
      </div>
    </div>
  );
};

PasswordResetSuccessModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PasswordResetSuccessModal;
